import { GA_SET_GAME, GA_SET_GAME_TYPE, GA_SET_GAME_STEP, GA_SET_LAST_PAGE_VIEW } from "./analyticsActions";

const INITIAL_STATE = {
    gameName: null,
    gameType: null,
    stepName: null,
    stepArray: [],
    lastPageView: null
}

export default (state = INITIAL_STATE, action) => {
    let stepArray = [];

    switch (action.type) {
        case GA_SET_GAME:
            return {
                ...state,
                gameName: action.payload
            }
        case GA_SET_GAME_TYPE:
            return {
                ...state,
                gameType: action.payload
            }
        case GA_SET_GAME_STEP:
            if (action.payload != null) {
                stepArray = state.stepArray;
                stepArray.push(action.payload);
            }

            return {
                ...state,
                stepName: action.payload,
                stepArray: stepArray
            }
        case GA_SET_LAST_PAGE_VIEW:
            return {
                ...state,
                lastPageView: action.payload
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/analytics/analyticsReducer.js